import { Link } from 'react-router-dom';
import { Dice5, Circle, Coins, TrendingUp, ArrowRight } from 'lucide-react';
import styles from './Games.module.css';

const games = [
	{
		icon: Dice5,
		name: 'Dice',
		description:
			'Classic dice game with customizable win probability. Players choose their target and roll to win.',
		houseEdge: '1%',
		link: '/docs/games-dice',
		color: '#10b981',
	},
	{
		icon: Circle,
		name: 'Plinko',
		description:
			'Drop balls through a pyramid of pegs for multiplied payouts. Multiple risk levels available.',
		houseEdge: '1%',
		link: '/docs/games-plinko',
		color: '#3b82f6',
	},
	{
		icon: Coins,
		name: 'Coin Flip',
		description:
			'Simple 50/50 coin flip with near-even odds. Quick rounds for high-frequency players.',
		houseEdge: '2%',
		link: '/docs/games-coinflip',
		color: '#f59e0b',
	},
	{
		icon: TrendingUp,
		name: 'Crash',
		description:
			'Multiplayer crash game with rising multipliers. Cash out before the crash to win big.',
		houseEdge: '3%',
		link: '/docs/games-crash',
		color: '#ef4444',
	},
];

export default function Games() {
	return (
		<section className={styles.games} id="games">
			<div className={styles.container}>
				<div className={styles.header}>
					<span className={styles.badge}>Games</span>
					<h2 className={styles.title}>Ready-to-Launch Casino Games</h2>
					<p className={styles.subtitle}>
						Four provably fair games with customizable house edges. Each game is
						optimized for player engagement and operator profitability.
					</p>
				</div>

				<div className={styles.grid}>
					{games.map((game) => {
						const Icon = game.icon;
						return (
							<div key={game.name} className={styles.card}>
								<div
									className={styles.iconWrapper}
									style={{ '--game-color': game.color } as React.CSSProperties}
								>
									<Icon size={28} className={styles.icon} />
								</div>
								<div className={styles.cardContent}>
									<div className={styles.cardHeader}>
										<h3 className={styles.cardTitle}>{game.name}</h3>
										<span className={styles.houseEdge}>
											{game.houseEdge} Edge
										</span>
									</div>
									<p className={styles.cardDescription}>{game.description}</p>
									<Link to={game.link} className={styles.cardLink}>
										Learn more
										<ArrowRight size={16} />
									</Link>
								</div>
							</div>
						);
					})}
				</div>

				<div className={styles.footer}>
					<p className={styles.footerText}>
						All games are fully customizable with configurable odds, betting limits,
						and visual themes.
					</p>
					<Link to="/docs" className={styles.footerLink}>
						View full game documentation
						<ArrowRight size={16} />
					</Link>
				</div>
			</div>
		</section>
	);
}
